export default __webpack_public_path__ + "9c14443e87397e0c57eef4ce261c6887.jpg";